import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { CheckoutButton } from "./CheckoutButton";
import { useSite, useImages } from "@/context/SiteContent";

const KEY = "tw_exit_intent_shown";

export const ExitIntent = () => {
  const { price, bookingCta } = useSite();
  const images = useImages();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(KEY)) return undefined;
    const isMobile = typeof window !== "undefined" && window.matchMedia("(max-width: 768px)").matches;
    let armed = false;
    const arm = setTimeout(() => { armed = true; }, isMobile ? 2500 : 4000);

    const trigger = () => {
      if (!armed) return false;
      sessionStorage.setItem(KEY, "1");
      setShow(true);
      return true;
    };

    // Desktop: mouse leaves toward the top of the window
    const onLeave = (e) => { if (e.clientY <= 0 && trigger()) document.removeEventListener("mouseout", onLeave); };

    // Mobile: trap the first back navigation
    const onPop = () => { if (armed && !sessionStorage.getItem(KEY)) { window.history.pushState(null, "", window.location.href); trigger(); } };

    // Mobile: engaged reader scrolls quickly back to the top (a leaving signal)
    let maxScroll = 0; let lastY = window.scrollY;
    const onScroll = () => {
      const y = window.scrollY;
      maxScroll = Math.max(maxScroll, y);
      if (armed && maxScroll > 600 && y < 120 && lastY - y > 24) { window.removeEventListener("scroll", onScroll); trigger(); }
      lastY = y;
    };

    if (isMobile) {
      window.history.pushState(null, "", window.location.href);
      window.addEventListener("popstate", onPop);
      window.addEventListener("scroll", onScroll, { passive: true });
    } else {
      document.addEventListener("mouseout", onLeave);
    }

    return () => {
      clearTimeout(arm);
      document.removeEventListener("mouseout", onLeave);
      window.removeEventListener("popstate", onPop);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const close = () => setShow(false);
  if (!show) return null;

  return (
    <div className="exit-overlay" onClick={close} data-testid="exit-intent-overlay">
      <div className="exit-modal" onClick={(e) => e.stopPropagation()} data-testid="exit-intent-modal">
        <button className="exit-close" onClick={close} aria-label="Close" data-testid="exit-intent-close"><X size={18} /></button>
        <div className="exit-grid">
          <div className="exit-visual"><img src={images.cover} alt="From Campus to Corporate eBook" /></div>
          <div className="exit-copy">
            <span className="eyebrow">Before you go</span>
            <h3>Take the whole journey with you.</h3>
            <p>52 lessons and the full 5Ps framework, ready whenever a new transition arrives. A one-time {price}, no subscription.</p>
            <div className="exit-actions">
              <CheckoutButton className="btn btn-gold btn-block" testId="exit-intent-checkout">Get the eBook • {price}</CheckoutButton>
              <a className="btn exit-book" href="#booking" onClick={close} data-testid="exit-intent-booking">{bookingCta}</a>
              <a className="exit-secondary" href="#sample" onClick={close} data-testid="exit-intent-sample">Not ready? Read one lesson free first</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
